import { render, staticRenderFns } from "./WorkGroupForm.vue?vue&type=template&id=7a6feeab"
import script from "./WorkGroupForm.vue?vue&type=script&lang=js"
export * from "./WorkGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports